/**
 * Video Block Play/Pause Toggle
 * Adds a play/pause button to core/video blocks.
 */
document.addEventListener('DOMContentLoaded', function () {
	const videoBlocks = document.querySelectorAll('.wp-block-video');

	videoBlocks.forEach(function (block) {
		var video = block.querySelector('video');

		if (!video) {
			return;
		}

		// Skip if video has native controls enabled.
		if (video.hasAttribute('controls')) {
			return;
		}

		if (block.querySelector('.video-toggle')) {
			return;
		}

		var toggleBtn = document.createElement('button');
		toggleBtn.className = 'video-toggle';
		toggleBtn.setAttribute('aria-label', 'Pause video');
		toggleBtn.setAttribute('type', 'button');

		// Set initial icon based on video state.
		var isPaused = video.paused;
		toggleBtn.innerHTML = isPaused
			? '<span class="dashicons dashicons-controls-play"></span>'
			: '<span class="dashicons dashicons-controls-pause"></span>';

		toggleBtn.addEventListener('click', function (e) {
			e.preventDefault();
			if (video.paused) {
				video.play();
				toggleBtn.innerHTML = '<span class="dashicons dashicons-controls-pause"></span>';
				toggleBtn.setAttribute('aria-label', 'Pause video');
			} else {
				video.pause();
				toggleBtn.innerHTML = '<span class="dashicons dashicons-controls-play"></span>';
				toggleBtn.setAttribute('aria-label', 'Play video');
			}
		});

		// Insert after the video element, not at the end of the figure
		// (to avoid being placed after figcaption).
		video.insertAdjacentElement('afterend', toggleBtn);
	});
});
